<script setup lang="ts">
import { onMounted, ref } from 'vue';

const props = defineProps<{
  devices?: Device[]
  currentDevice?: Device
  currentCenter?: [number, number]
}>()

const zoom = ref(10);
const map = ref(null);
const emit = defineEmits(['markerClick','centerChange']);

onMounted(async () => {
  
})

watch(() => props.currentDevice, (newDevice) => {
    map.value.leafletObject.flyTo([newDevice.latitude, newDevice.longitude],zoom.value,{animate: true,duration: 1,});
  },
);

watch(() => props.currentCenter, (newCenter) => {
    map.value.leafletObject.flyTo([newCenter[0], newCenter[1]],zoom.value,{animate: true,duration: 1,});
  },
);

</script>

<template>
    <div style="height:30vh; width:100%">
      <LMap
        ref="map"
        :zoom="zoom"
        :center="[52.41062886351636, 16.94020481007622]"
        :use-global-leaflet="false"
        v-on:update:center="(center: [number, number]) => {
          emit('centerChange', center);
        }">
        <LTileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&amp;copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors"
          layer-type="base"
          name="OpenStreetMap"
        />
        <LMarker
        v-for="device in props.devices"
        :key="device.id"
        :lat-lng="[device.latitude, device.longitude]"
        v-on:click="() => emit('markerClick', device)"
        >
        <LPopup>{{ device.name }}</LPopup>
      </LMarker>
      </LMap>
    </div>
  </template>

<style scoped>
</style>